import { render, staticRenderFns } from "./b4-request-demo.vue?vue&type=template&id=29aa13a0&"
import script from "./b4-request-demo.vue?vue&type=script&lang=ts&"
export * from "./b4-request-demo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\projects\\git\\b4\\b4-marketing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('29aa13a0', component.options)
    } else {
      api.reload('29aa13a0', component.options)
    }
    module.hot.accept("./b4-request-demo.vue?vue&type=template&id=29aa13a0&", function () {
      api.rerender('29aa13a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "source/scripts/components/forms/b4-request-demo.vue"
export default component.exports